import { ResponseArray } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import qs from 'qs'
import { ProductGroup } from '../types'

export const getProductsGroup = async (
    params?: object
): Promise<ResponseArray<ProductGroup>> => {
    const query = params ? `?${qs.stringify(params)}` : ''
    const response = await datacentral.get(`/product-groups${query}`)
    return response.data
}

export const getProductsGroupOptions = async (_query?: string) => {
    const response = await getProductsGroup()
    if (!response?.results) return []
    return response?.results?.map((item) => ({
        label: item?.product_group_name,
        value: item?.product_group_name,
    }))
}
